import { useLibraryFolder } from '@stores/Library/LibraryFolder';
import { trackingStore } from '@stores/Tracking';
import { useCallback } from 'react';
import { MediaTableRow } from '../cells/types';

export const useSelectionManagement = (mediaData: MediaTableRow[]) => {
  const folder = useLibraryFolder();

  // Handle selection change from DataGrid
  const handleSelectionChange = useCallback(
    (newSelection: any) => {
      // Extract selected IDs from the selection model
      let selectedIds: string[] = [];

      if (Array.isArray(newSelection)) {
        // Simple array format
        selectedIds = newSelection.map(String);
      } else if (newSelection && typeof newSelection === 'object') {
        // Object format with ids property
        if (newSelection.ids) {
          let ids: string[] = [];
          if (Array.isArray(newSelection.ids)) {
            ids = newSelection.ids.map(String);
          } else if (newSelection.ids instanceof Set) {
            ids = Array.from(newSelection.ids).map(String);
          }

          if (newSelection.type === 'include') {
            // Include mode: ids are the selected items
            selectedIds = ids;
          } else if (newSelection.type === 'exclude') {
            // Exclude mode: ids are the excluded items, so we need to find all items NOT in the excluded list
            const allItemIds = mediaData.map((item) => item._id);
            selectedIds = allItemIds.filter((id) => !ids.includes(id));
          }
        }
      }

      // Always set isSelecting based on whether we have selections
      folder.videoSelection.setIsSelecting(selectedIds.length > 0);

      // Update the selected items
      folder.videoSelection.selectedItems.clear();
      selectedIds.forEach((id: string) => folder.videoSelection.selectedItems.add(id));

      trackingStore.mediaSelectionChanged({ totalSelected: selectedIds.length });
    },
    [folder.videoSelection, mediaData],
  );

  return {
    handleSelectionChange,
  };
};
